import { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/styles';

import { useCurrentUser } from '@bizzabo/entities';

import StartNetworkingCard from './StartNetworkingCard';
import ContactListWrapper from '../../../components/ContactListWrapper';
import PanelSearch from '../../../components/PanelSearch';
import { useMeetings, View } from '../../MeetingsTool/MeetingsToolContext';
import useTypeTracking from '../../../../analytics';

const ContactListPage: React.FC = () => {
    const { eventId, openWizard, setView } = useMeetings();
    const { data: user } = useCurrentUser(eventId);
    const [searchTerm, setSearchTerm] = useState('');
    const isFirstType = useRef(true);
    const classes = useStyles();
    const { trackClickEvent, trackSystemEvent } = useTypeTracking({
        data: {
            description: {
                location: 'MEETING_WIZARD',
                flow: 'CREATE_MEETING',
                meeting_participant_role: 'HOST',
            },
        },
    });

    const handleContactItemClick = (attendeeId: number) => {
        openWizard({ otherAttendeeId: attendeeId });
    };

    const onSearchHandle = (searchText: string) => {
        setSearchTerm(searchText);
        if (isFirstType.current) {
            trackSystemEvent({
                description: {
                    action: 'SEARCH_CONTACT_START',
                },
            });
            isFirstType.current = false;
        }
    };

    const handleCloseSearch = () => {
        setView(View.ZeroState);
        trackClickEvent({
            subCategory: 'CANCEL_CONTACT_SEARCH',
        });
    };

    return (
        <div className={classes.wrapper}>
            <div className={classes.header}>
                <PanelSearch
                    onChange={onSearchHandle}
                    closeSearch={handleCloseSearch}
                    placeholder="Search contacts"
                />
            </div>
            <StartNetworkingCard user={user} />
            <ContactListWrapper
                eventId={eventId}
                searchTerm={searchTerm}
                onContactItemClick={handleContactItemClick}
            />
        </div>
    );
};

const useStyles = makeStyles(
    () => ({
        wrapper: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        header: {
            padding: '0 20px',
        },
    }),
    { classNamePrefix: 'meetings-contacts-page' }
);

export default ContactListPage;
